import { useEffect, useRef } from "react";
import { Chakra } from "@airhelp/react-ui-components";
import { SideMenuIcon } from "styles/icons";
import { useRouter } from "next/router";
import SideMenu from "../SideMenu";
import type { SideMenuProps } from "../SideMenu.d";

const { Button, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerBody } = Chakra;

const SideMenuMobileAdapter = ({ pageHeading }: SideMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  const { events } = useRouter();

  useEffect(() => {
    events.on("hashChangeStart", onClose);

    return () => {
      events.off("hashChangeStart", onClose);
    };
  }, [events, onClose]);

  return (
    <>
      <Button ref={btnRef} onClick={onOpen} aria-label="Open list of contents" variant="unstyled" color="primary.900">
        <SideMenuIcon w={7} />
      </Button>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton borderRadius="50%" size="lg" _hover={{ color: "primary.500" }} />
          <DrawerBody mt={16}>
            <SideMenu pageHeading={pageHeading} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SideMenuMobileAdapter;
